import React from 'react'
import { Form } from 'react-bootstrap'

const SelectInput = React.forwardRef((props = {}, ref) => {
  const {
    onChange,
    onBlur,
    name,
    label,
    errors = {},
    options = [],
    placeholder,
  } = props
  return (
    <Form.Group className="mb-3" controlId={name}>
      <Form.Label>
        {label}
        <span className="text-danger ml-0.5 text-base">*</span>
      </Form.Label>
      <Form.Select
        required
        className="shadow-none form-control"
        name={name}
        ref={ref}
        onChange={onChange}
        onBlur={onBlur}
        isInvalid={errors[name]}
      >
        <option value="">{placeholder}</option>
        {options.map((label) => (
          <option key={label} value={label?.value || label}>
            {label?.label || label}
          </option>
        ))}
      </Form.Select>
      <Form.Control.Feedback type="invalid">
        {errors?.[name]?.message || ''}
      </Form.Control.Feedback>
    </Form.Group>
  )
})

export default SelectInput
